import AboutSeries from './AboutSeries'

export default AboutSeries
// eslint-disable-next-line import/export
export * from './AboutSeries'
